// context/initialState.js
export const initialState = {
    menus: [],
    userChoices: [], // Ensure this is an array
    mainCategoryID: null,
    mainCategoryName: '',
    activeMenu: null,
    subCategoryID: null,
    itemChoices: {},
    chosenCategory: [],
    filteredItems: [],
    activeMenusubCategory: null, // Add this line
    totalMonthPrice: 0,
    userOrder: null,
};
